import React from 'react';
import { truncateParty, formatCC } from '../../utils/formatters';

export function TransactionRow({ tx }) {
  const type = tx.transaction_type || 'other';

  const typeIcons = {
    transfer: '↔',
    mint: '+',
    tap: '•',
    other: '•',
  };

  const getSenderReceiver = () => {
    if (tx.transfer) {
      return {
        sender: tx.transfer.sender?.party,
        receiver: tx.transfer.receivers?.[0]?.party,
        amount: tx.transfer.receivers?.[0]?.amount,
      };
    }
    if (tx.tap) {
      return {
        sender: null,
        receiver: tx.tap.amuletOwner,
        amount: tx.tap.amuletAmount,
      };
    }
    if (tx.mint) {
      return {
        sender: null,
        receiver: tx.mint.receiver,
        amount: tx.mint.amount,
      };
    }
    return { sender: null, receiver: null, amount: null };
  };

  const { sender, receiver, amount } = getSenderReceiver();

  // Format time ago
  const formatTimeAgo = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    const weeks = Math.floor(days / 7);
    return `${weeks}w ago`;
  };

  const price = tx.amulet_price ? parseFloat(tx.amulet_price) : null;

  return (
    <>
      {/* Desktop row */}
      <div className="hide-mobile" style={{
        display: 'grid',
        gridTemplateColumns: '70px minmax(0, 1fr) 24px minmax(0, 1fr) 90px 70px 60px',
        gap: '12px',
        padding: '12px 16px',
        borderBottom: '1px solid var(--border-subtle)',
        alignItems: 'center',
        fontSize: '13px',
      }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          textTransform: 'uppercase',
        }}>
          <span>{typeIcons[type] || typeIcons.other}</span>
          {type}
        </div>
        <div style={{
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {sender ? truncateParty(sender) : '—'}
        </div>
        <div style={{
          color: 'var(--text-disabled)',
          fontSize: '12px',
          textAlign: 'center',
        }}>
          →
        </div>
        <div style={{
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          {receiver ? truncateParty(receiver) : '—'}
        </div>
        <div style={{
          color: 'var(--text-secondary)',
          fontFamily: 'var(--font-mono)',
          fontWeight: '600',
          fontSize: '11px',
          textAlign: 'right',
        }}>
          {amount ? `${formatCC(amount)} CC` : '—'}
        </div>
        <div style={{
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          textAlign: 'right',
        }}>
          {price ? `$${price.toFixed(4)}` : '—'}
        </div>
        <div style={{
          color: 'var(--text-disabled)',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          textAlign: 'right',
        }}>
          {formatTimeAgo(tx.date)}
        </div>
      </div>
      {/* Mobile row */}
      <div className="show-mobile-only" style={{
        display: 'flex',
        padding: '10px 12px',
        borderBottom: '1px solid var(--border-subtle)',
        alignItems: 'center',
      }}>
        <div style={{
          width: '55px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '9px',
          textTransform: 'uppercase',
        }}>
          <span>{typeIcons[type] || typeIcons.other}</span>
          {type.slice(0, 5)}
        </div>
        <div style={{
          flex: 1,
          color: 'var(--text-secondary)',
          fontFamily: 'var(--font-mono)',
          fontWeight: '600',
          fontSize: '11px',
          textAlign: 'right',
        }}>
          {amount ? `${formatCC(amount)} CC` : '—'}
        </div>
        <div style={{
          width: '60px',
          flexShrink: 0,
          color: 'var(--text-tertiary)',
          fontFamily: 'var(--font-mono)',
          fontSize: '10px',
          textAlign: 'right',
        }}>
          {price ? `$${price.toFixed(4)}` : '—'}
        </div>
        <div style={{
          width: '45px',
          flexShrink: 0,
          color: 'var(--text-disabled)',
          fontFamily: 'var(--font-mono)',
          fontSize: '9px',
          textAlign: 'right',
        }}>
          {formatTimeAgo(tx.date).replace(' ago', '')}
        </div>
      </div>
    </>
  );
}
